<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="600px"
    :close-on-click-modal="false"
    destroy-on-close
    class="app-main-inner edi-selector-dialog"
  >
    <div class="app-main-inner-row">
      <el-button no="select" type="primary" @click="toSelectRow">{{ $t('CargoMsg.Cargo_Select') }}</el-button>
    </div>
    <div class="app-main-inner-row row-grid-dialog" style="height: 350px;padding-bottom: 20px;">

      <cargo-ag-grid
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'

export default {
  name: 'ApiPopup',
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, default: '' },
    interfaceType: { type: Number, default: 1 }, // 接口类型  1.订舱  2.舱单  3.装箱单 4、提单 5、装箱信息
    interfaceArray: { type: String, default: '' } // 接口集合
  },
  data() {
    return {
      innerVisible: false,
      gridParams: {},
      rowData: [],
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        onRowDoubleClicked: (event) => {
          this.doSelectRow({ ...event.data })
        },
        pagination: false
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'id',
          colId: 'id',
          hide: true,
          flex: 1
        }, {
          headerName: this.$t('SeaExport.Interface'),
          field: 'interface',
          colId: 'interface',
          flex: 1
        }, {
          headerName: this.$t('Payment.remarks'),
          field: 'remarks',
          colId: 'remarks',
          flex: 1
        }
      ]
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (this.innerVisible) {
        this.load()
      }
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    load() {
      if (!this.interfaceArray) return
      const interfaces = this.interfaceArray.split(',')
      // 组装数据源
      const dataArray = []
      // 订舱接口
      if (this.interfaceType === 1) {
        for (let i = 0; i < interfaces.length; i++) {
          if (interfaces[i] === '1') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.Sinotrans'), 'remarks': this.$t('SeaExport.SinotransEastChinaCoLtd') }
            dataArray.push(data)
          } else if (interfaces[i] === '2') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.NingboEPort'), 'remarks': this.$t('SeaExport.NingboEPort') }
            dataArray.push(data)
          } else if (interfaces[i] === '3') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.JiLianStar'), 'remarks': this.$t('SeaExport.JiLianStar') }
            dataArray.push(data)
          } else if (interfaces[i] === '4') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.MingShen'), 'remarks': this.$t('SeaExport.MingShenCompany') }
            dataArray.push(data)
          }
        }
      } else if (this.interfaceType === 2) {
        for (let i = 0; i < interfaces.length; i++) {
          if (interfaces[i] === '1') {
            const data1 = { 'id': interfaces[i], 'interface': this.$t('SeaExport.NingboEPort'), 'remarks': this.$t('SeaExport.NingboEPort') }
            // const data2 = { 'id': '3', 'interface': this.$t('SeaExport.SeaHousekeeper'), 'remarks': this.$t('SeaExport.SeaHousekeeper') }
            // const data3 = { 'id': '4', 'interface': this.$t('SeaExport.Wse'), 'remarks': this.$t('SeaExport.Wse') }
            dataArray.push(data1)
            // dataArray.push(data2)
            // dataArray.push(data3)
          } else if (interfaces[i] === '2') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.JiLianStar'), 'remarks': this.$t('SeaExport.JiLianStar') }
            dataArray.push(data)
          } else if (interfaces[i] === '5') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.MingShen'), 'remarks': this.$t('SeaExport.MingShenCompany') }
            dataArray.push(data)
          }
        }
      } else if (this.interfaceType === 3) {
        for (let i = 0; i < interfaces.length; i++) {
          if (interfaces[i] === '1') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.Ningbo99Road'), 'remarks': this.$t('SeaExport.Ningbo99Road') }
            dataArray.push(data)
          } else if (interfaces[i] === '2') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.NingboEPort'), 'remarks': this.$t('SeaExport.NingboEPort') }
            dataArray.push(data)
          }
        }
      } else if (this.interfaceType === 4) {
        for (let i = 0; i < interfaces.length; i++) {
          if (interfaces[i] === '1') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.NingboEPort'), 'remarks': this.$t('SeaExport.NingboEPort') }
            dataArray.push(data)
          }
        }
      } else if (this.interfaceType === 5) {
        for (let i = 0; i < interfaces.length; i++) {
          if (interfaces[i] === '1') {
            const data = { 'id': interfaces[i], 'interface': this.$t('SeaExport.MingShen'), 'remarks': this.$t('SeaExport.MingShenCompany') }
            dataArray.push(data)
          }
        }
      }
      this.rowData = dataArray
    },
    toSelectRow() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        } else {
          this.doSelectRow(getGridSelected(this.gridOptions)[0])
        }
      })
    },
    doSelectRow(row) {
      this.$emit('selectedApi', row)
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
.edi-selector-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
